function realSessionId(sessionId) {
  if (sessionId == null || sessionId === '') return '';
  const value = String(sessionId);
  if (value.startsWith('sch-')) return '';
  return value;
}

/**
 * Canonical web path for managing a class (attendance, homework, start, zoom).
 * Always include sessionDate when known so a future calendar slot does not
 * fall back to the last delivered class.
 */
export function buildBatchSessionPath(
  batchId,
  sessionId,
  { action, sessionDate, startTime, endTime } = {}
) {
  if (!batchId) return null;
  const params = new URLSearchParams();
  const id = realSessionId(sessionId);
  if (id) params.set('sessionId', id);
  if (sessionDate) params.set('sessionDate', String(sessionDate).slice(0, 10));
  if (!id) {
    if (startTime) params.set('startTime', String(startTime).slice(0, 8));
    if (endTime) params.set('endTime', String(endTime).slice(0, 8));
  }
  if (action) params.set('action', action);
  const qs = params.toString();
  return `/batches/${encodeURIComponent(batchId)}${qs ? `?${qs}` : ''}`;
}
